import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function ChangerMotDePassePage() {
  const navigate = useNavigate();
  const { utilisateur, logout } = useAuth();
  const estPremierLogin = utilisateur?.premier_login;

  const [form, setForm] = useState({ ancien_mot_de_passe: '', nouveau_mot_de_passe: '', confirmer: '' });
  const [message, setMessage] = useState({ type: '', texte: '' });
  const [chargement, setChargement] = useState(false);

  const champ = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const soumettre = async (e) => {
    e.preventDefault();
    if (form.nouveau_mot_de_passe !== form.confirmer) {
      setMessage({ type: 'erreur', texte: '❌ Les mots de passe ne correspondent pas.' });
      return;
    }
    if (form.nouveau_mot_de_passe.length < 6) {
      setMessage({ type: 'erreur', texte: '❌ Le mot de passe doit contenir au moins 6 caractères.' });
      return;
    }
    setChargement(true);
    try {
      await api.put('/users/changer-mot-de-passe', {
        ancien_mot_de_passe: form.ancien_mot_de_passe,
        nouveau_mot_de_passe: form.nouveau_mot_de_passe,
      });
      setMessage({ type: 'succes', texte: '✅ Mot de passe changé avec succès ! Reconnexion...' });
      setTimeout(() => {
        logout();
        navigate('/login');
      }, 2000);
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur serveur.' });
    } finally { setChargement(false); }
  };

  const S = {
    page: { minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center' },
    card: { background: 'white', borderRadius: 12, padding: 40, width: 450, boxShadow: '0 4px 20px rgba(0,0,0,0.12)', borderTop: `6px solid ${estPremierLogin ? '#e67e22' : '#1a5c2a'}` },
    logo: { width: 180, display: 'block', margin: '0 auto 20px' },
    titre: { color: estPremierLogin ? '#e67e22' : '#1a5c2a', fontSize: 22, fontWeight: 'bold', textAlign: 'center', marginBottom: 8 },
    sousTitre: { color: '#666', fontSize: 13, textAlign: 'center', marginBottom: 25 },
    label: { display: 'block', fontSize: 13, color: '#555', marginBottom: 5, fontWeight: '600' },
    input: { width: '100%', padding: '12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14, marginBottom: 15, boxSizing: 'border-box' },
    btn: { background: estPremierLogin ? '#e67e22' : '#1a5c2a', color: 'white', border: 'none', padding: '14px', borderRadius: 8, fontSize: 16, fontWeight: 'bold', cursor: 'pointer', width: '100%', marginTop: 5 },
    alerte: (t) => ({ padding: '12px', borderRadius: 8, marginBottom: 15, background: t === 'succes' ? '#d4edda' : '#f8d7da', color: t === 'succes' ? '#155724' : '#721c24', textAlign: 'center' }),
    info: { background: '#fff3cd', border: '1px solid #ffc107', borderRadius: 8, padding: 12, marginBottom: 20, fontSize: 13, color: '#856404' },
    lienRetour: { textAlign: 'center', marginTop: 15, fontSize: 13, color: '#888' },
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <img src="/logo-sogas.png" alt="SOGAS" style={S.logo} />
        <div style={S.titre}>{estPremierLogin ? '🔑 Définir votre mot de passe' : '🔒 Changer le mot de passe'}</div>
        <div style={S.sousTitre}>
          {utilisateur ? `${utilisateur.prenom} ${utilisateur.nom} — ${utilisateur.email}` : ''}
        </div>

        {estPremierLogin && (
          <div style={S.info}>
            ⚠️ <strong>Première connexion !</strong> Pour des raisons de sécurité, vous devez définir votre propre mot de passe avant de continuer.
          </div>
        )}

        {message.texte && <div style={S.alerte(message.type)}>{message.texte}</div>}

        <form onSubmit={soumettre}>
          {!estPremierLogin && (
            <div>
              <label style={S.label}>Mot de passe actuel</label>
              <input style={S.input} type="password" name="ancien_mot_de_passe" value={form.ancien_mot_de_passe} onChange={champ} placeholder="Votre mot de passe actuel" required={!estPremierLogin} />
            </div>
          )}
          <div>
            <label style={S.label}>Nouveau mot de passe</label>
            <input style={S.input} type="password" name="nouveau_mot_de_passe" value={form.nouveau_mot_de_passe} onChange={champ} placeholder="Minimum 6 caractères" required />
          </div>
          <div>
            <label style={S.label}>Confirmer le nouveau mot de passe</label>
            <input style={S.input} type="password" name="confirmer" value={form.confirmer} onChange={champ} placeholder="Répétez le mot de passe" required />
          </div>
          <button type="submit" style={S.btn} disabled={chargement}>
            {chargement ? '⏳ Changement...' : estPremierLogin ? '✅ DÉFINIR MON MOT DE PASSE' : '🔒 CHANGER LE MOT DE PASSE'}
          </button>
        </form>

        {!estPremierLogin && (
          <div style={S.lienRetour}>
            <span style={{ cursor: 'pointer', color: '#1a5c2a' }} onClick={() => navigate('/dashboard')}>← Retour au tableau de bord</span>
          </div>
        )}
      </div>
    </div>
  );
}
